import '../../css/loader.css';

const Cargando = () => {
  return (
    <div
      style={{
        backgroundColor: '#5280af',
        padding: '0',
        margin: '0',
        height: '100vh',
        width:'100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div className="loader">
        <span>C</span>
        <span>A</span>
        <span>R</span>
        <span>G</span>
        <span>A</span>
        <span>N</span>
        <span>D</span>
        <span>O</span>
      </div>
    </div>
  )
}

export default Cargando;